/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Virtual network configuration for network interface creation
*/
export class VNetConfig {
  /**
  * Whether to use an existing VNet or create a new one
  */
  'mode': VNetConfigModeEnum;
  /**
  * VNet name. Required when mode=existing. Optional when mode=create (defaults to eon-default-vnet-<region>). 
  */
  'name'?: string;
  /**
  * Address space in CIDR notation. Only used when mode=create. Defaults to 10.0.0.0/16 if not specified. 
  */
  'addressSpace'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "mode",
      "baseName": "mode",
      "type": "VNetConfigModeEnum",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "addressSpace",
      "baseName": "addressSpace",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return VNetConfig.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum VNetConfigModeEnum {
  Existing = 'existing',
  Create = 'create'
}

